export default __webpack_public_path__ + "static/media/success.8ea5e21c.svg";